export class CustomQuestionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCustomQuestions() {
    return this.#http.get('/CustomQuestions');
  }

  async createCustomQuestions(body) {
    return this.#http.post('/CustomQuestions', body);
  }

  async editCustomQuestions(body) {
    return this.#http.put('/CustomQuestions', body);
  }

  async getCustomQuestionsByCustomQuestionId({ customQuestionId }) {
    return this.#http.get(`/CustomQuestions/${customQuestionId}`);
  }

  async deleteCustomQuestions({ customQuestionId }) {
    return this.#http.delete(`/CustomQuestions/${customQuestionId}`);
  }

  async getCustomQuestionsExpressionEngineSchema() {
    return this.#http.get('/CustomQuestions/expression-engine-schema');
  }

  async getCustomQuestionsFilterCustomQuestionsByApplicationId({ applicationId }) {
    return this.#http.get(`/CustomQuestions/filter-custom-questions/${applicationId}`);
  }

  async editCustomQuestionsSortOrder(body) {
    return this.#http.put('/CustomQuestions/sort-order', body);
  }
}
